export default __webpack_public_path__ + "tutorial-1@2x.b6a3aeb6.png";